import React, { useContext, useState } from "react";
import { ModalContext } from "../context/ModalContext";
import Navbar from "../components/global/Navbar";
import PartnerStudio from "../components/partners/PartnerStudio";
import MonterreyLandingClassTypes from "../components/monterrey/MonterreyLandingClassTypes";
import PartnersLandingAbout from "../components/partners/PartnersLandingAbout";
import LandingImageBanner from "../components/monterrey/MonterreyLandingBanner";
import MonterreyFooter from "../components/monterrey/MonterreyFooter";
import PartnerApplyForm from "../components/partners/PartnerApplyForm";
import AddressFilter from "../components/address/AddressFilter";
import "./LandingMonterrey.css";
import "./LandingPartners.css";
import Footer from "../components/global/Footer";

const PARTNERS = [
  {
    logo: "/img/n1-logo-light.png",
    image: "/img/n1-slider-img.jpg",
    title: "N1 STUDIO",
    address: "4100 Bonita Road\nBonita CA 91902",
    country: "US",
    state: "CA",
    city: "San Diego",
    google_maps_url:
      "https://www.google.com/maps/search/?api=1&query=4100+Bonita+Road+Bonita+CA+91902",
    bookings_url: "https://www.wellnessliving.com/login/n1_studio",
    email: "info@n1studiosd.com",
    socialLinks: [
      {
        type: "instagram",
        url: "https://www.instagram.com/n1studiooficial",
        label: "Instagram",
      },
      { type: "web", url: "https://www.n1studiosd.com", label: "Web" },
      {
        type: "whatsapp",
        url: "https://wa.me/+16199366957",
        label: "WhatsApp",
      },
    ],
    instructors: [
      { image: "/img/karla-banuelos-home.jpg", name: "Karla Bañuelos" },
      { image: "/img/majo-seaman-home.jpg", name: "Majo Seaman" },
    ],
    class_types: [{ name: "Block Burn Pilates" }],
  },
];

const LandingPartners = () => {
  const { modalComponent, clearModal } = useContext(ModalContext);
  const [filters, setFilters] = useState({});

  const openPartnerForm = () => {
    modalComponent(
      "Apply to become a TBM Partner Studio",
      <PartnerApplyForm handleCancel={clearModal} />,
      {
        size: "lg",
        centered: true,
      },
    );
  };

  const filteredPartners = PARTNERS.filter((partner) => {
    if (filters.country_code && partner.country !== filters.country_code)
      return false;
    if (filters.state_code && partner.state !== filters.state_code)
      return false;
    if (filters.city && partner.city !== filters.city) return false;
    if (
      filters.search &&
      !partner.title?.toLowerCase().includes(filters.search.toLowerCase())
    )
      return false;
    return true;
  });

  const scrollToFilter = () => {
    document.getElementById("partners-filter")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <div>
      <Navbar />
      <section
        className="partners-hero"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/partners-banner.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center 80%",
        }}
      >
        <div className="container">
          <div className="partners-header text-center py-5">
            <h1 className="partners-header__title">
              Find a TBM Partner Studio
            </h1>
            <p className="partners-header__subtitle">
              Official studios authorized to teach TBM Methodology
            </p>
            <div className="partners-header__ctas d-flex flex-wrap gap-3 justify-content-center mt-4">
              <button
                type="button"
                className="btn btn-primary partners-header__cta-primary px-4 py-2"
                onClick={scrollToFilter}
              >
                Choose a city
              </button>
              <a
                href="#become-partner-studio"
                className="btn partners-header__cta-secondary px-4 py-2"
              >
                Become a Partner
              </a>
            </div>
          </div>
          <div id="partners-filter" className="px-0 py-4">
            <AddressFilter
              onChange={(f) => setFilters(f)}
              placeholderCountry="País"
              placeholderState="Estado"
              placeholderCity="Ciudad"
              placeholderSearch="Buscar..."
              allowedCountryCodes={["MX", "US", "CA", "CO"]}
            />
          </div>
        </div>
      </section>
      <section className="partners-content bg-white">
        <div className="container">
          <div className="row g-4 mb-5 pb-5">
            {filteredPartners.length > 0 &&
              filteredPartners.map((partner, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <PartnerStudio
                    image={partner.image}
                    logo={partner.logo}
                    title={partner.title}
                    address={partner.address}
                    google_maps_url={partner.google_maps_url}
                    bookings_url={partner.bookings_url}
                    email={partner.email}
                    city={partner.city}
                    state={partner.state}
                    country={partner.country}
                    socialLinks={partner.socialLinks}
                    instructors={partner.instructors}
                    class_types={partner.class_types}
                  />
                </div>
              ))}
            {filteredPartners.length === 0 && (
              <div className="col-12">
                <p className="text-center text-muted py-4">
                  No se encontraron estudios con los filtros seleccionados.
                </p>
              </div>
            )}
          </div>

          <MonterreyLandingClassTypes
            fromPartners
            hideButton
            classTypeIds={[1, 7, 27]}
            title="¿Qué es un TBM Partner Studio?"
            subtitle="Un TBM Partner Studio es un estudio oficialmente afiliado a The Body Method y autorizado para impartir clases bajo la Metodología TBM. Sus coaches han sido entrenados y certificados, y el estudio cumple con lineamientos de calidad, seguridad y experiencia para asegurar que vivas el método tal como fue diseñado."
            description="Una experiencia consistente con la esencia de The Body Method: movimiento, transformación y comunidad."
          />
        </div>
        <div id="become-partner-studio">
          <PartnersLandingAbout onApplyClick={openPartnerForm} />
        </div>
      </section>
      <section className="bg-white">
        <LandingImageBanner
          src="/img/monterrey-banner.png"
          mobileSrc="/img/monterrey-banner-mobile.png"
          title="Become a Partner"
          buttonText="Apply now"
          onButtonClick={openPartnerForm}
        />
      </section>
      <Footer />
    </div>
  );
};

export default LandingPartners;
